import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "label", "input"]

  connect() {
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    document.addEventListener('click', this._outsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClick)
  }

  toggle() {
    this.menuTarget.classList.toggle('hidden')
  }

  close() {
    this.menuTarget.classList.add('hidden')
  }

  select(e) {
    const btn = e.currentTarget
    const value = btn.dataset.value
    const label = btn.dataset.label

    this.inputTarget.value = value
    this.labelTarget.textContent = label

    // Update active state
    this.menuTarget.querySelectorAll('[data-action]').forEach(el => {
      el.classList.remove('laz-model-active')
    })
    btn.classList.add('laz-model-active')

    this.close()
  }
}
